import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@cloudscape-design/components/box';
import Header from '@cloudscape-design/components/header';
import Table from '@cloudscape-design/components/table';
import { formatInt } from '@/features/dashboard-finance/formatters';
import type { TopLabelsRow } from './useUsageBasic';

/** Tabela das 10 contas que mais imprimiram no período. */
export function TopLabelsAccountsTable({
  rows,
}: {
  rows: readonly TopLabelsRow[];
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <Table<TopLabelsRow>
      items={[...rows]}
      trackBy="tenantId"
      variant="container"
      header={<Header variant="h3">{t('usageBasic.tables.topLabels.title', { count: rows.length })}</Header>}
      empty={<Box textAlign="center" color="inherit">{t('usageBasic.empty')}</Box>}
      columnDefinitions={[
        {
          id: 'account',
          header: t('usageBasic.tables.topLabels.account'),
          cell: (r): React.ReactNode => r.tenantName,
        },
        {
          id: 'country',
          header: t('usageBasic.tables.topLabels.country'),
          cell: (r): React.ReactNode => r.countryCode,
        },
        {
          id: 'labels',
          header: t('usageBasic.tables.topLabels.labels'),
          cell: (r): React.ReactNode => formatInt(r.totalLabels),
        },
      ]}
    />
  );
}
